const echostarContentTypeMap = {
    MOV: {name: 'Movie', type: 'franchise', filterForEpisodes: false},
    SPM: {name: 'Special', type: 'franchise', filterForEpisodes: false},
    SRM: {name: 'Show', type: 'franchise', filterForEpisodes: true},
    SRE: {name: 'Episode', type: 'episode', filterForEpisodes: false},
};

export default echostarContentTypeMap;
